import { FC } from "react";

interface ShareIconProps {
  className?: string;
  fill?: string;
}

const ShareIcon: FC<ShareIconProps> = ({ fill = "currentColor", className }) => (
  <svg x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" strokeWidth="2" className={className}>
    <g strokeWidth="2" transform="translate(0, 0)">
      <path
        d="M10,40H7a5,5,0,0,1-5-5V13A5,5,0,0,1,7,8H43a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H22"
        fill="none"
        stroke={fill}
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2"
        strokeLinejoin="miter"
      ></path>
      <path
        data-color="color-2"
        d="M54,24h3a5,5,0,0,1,5,5V51a5,5,0,0,1-5,5H21a5,5,0,0,1-5-5V29a5,5,0,0,1,5-5H42"
        fill="none"
        stroke={fill}
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2"
        strokeLinejoin="miter"
      ></path>
    </g>
  </svg>
);

export default ShareIcon;
